export default __webpack_public_path__ + "static/about-txt-en-8f29ed843bd99a37d13dc6455b89d198.png";